// import Hecate from '@bybit/hecate';
import { normalizeLink } from './i18n';
import { isApp, isClient } from './env';
import { nanoid } from 'nanoid';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { isInWeb3Mini } from './web3mini';

export const isBrowser = typeof window === 'object';

declare const window: any;

export const bybitHecate = (
  module: string,
  method: string,
  params: Record<string, any>
) =>
  // eslint-disable-next-line
  new Promise(async (resolve) => {
    if (!isApp()) {
      resolve({});
      return;
    }

    if (window.__POWERED_BY_WUJIE__) {
      const id = nanoid();
      const respEventName = `callHecateResp${id}`;

      window.$wujie?.bus.$once(respEventName, (res: any) => {
        resolve(res);
      });
      window.$wujie?.bus.$emit('callHecate', id, module, method, params);
    } else {
      const { default: Hecate } = await import('@bybit/hecate');

      Hecate.module(module)
        .method(method)
        .invoke(params)
        .then((res: any) => {
          resolve(res);
        });
    }
  });

export const openInsLogin = async () => {
  // bybitapp://open/login
  try {
    bybitHecate('Web3WalletBridge', 'openDeeplink', {
      app_name: 'Web3',
      deeplink: 'bybitapp://open/login', // 跳转到铭文搜索页面
    })
      .then((res: any) => {
        setTimeout(() => {
          window.parent.location.reload();
        }, 500);
      })
      .catch(() => {
        console.log('login:error');
      });
  } catch (error) {
    console.error(error);
  }
};

export const openAppLogin = async (onLoginSuccessCb?: () => void) => {
  try {
    bybitHecate('UserProfile', 'getUserProfile', { needLogin: true })
      .then((res: any) => {
        // 当前页面刷新
        console.log('getUserProfile', JSON.stringify(res));
        onLoginSuccessCb?.();
        if (res.params.uid) {
          setTimeout(() => {
            window.parent.location.reload();
          }, 500);
        }
      })
      .catch(() => {
        console.log('getUserProfile:error');
      });
  } catch (error) {
    console.error(error);
  }
};

export const BY_APP_PROTOCOL = 'bybitapp://';
export const BY_APP_INNER_PROTOCOL = ['by-mini://', 'by://'];
export const DownloadLink = `/download?utm_source=web3homepaged&utm_medium=picscann&utm_campaign=appdownload`;

export const openLink = async (path: string) => {
  const { setConfig, openApp } = await import('@sfe/bone-portal');
  setConfig({
    needView: true,
    downloadLink: DownloadLink,
  });

  const route = BY_APP_INNER_PROTOCOL.some((p) => path.startsWith(p))
    ? `${BY_APP_PROTOCOL}open/route?targetUrl=${encodeURIComponent(path)}`
    : path;
  if (/bybit_app/.test(navigator.userAgent.toLowerCase())) {
    bybitHecate('Router', 'push', { path: route });
    return;
  }
  return openApp(route);
};

export const downloadPath = '/download';

export const switchWallet = async (
  onSuccessCb: () => void,
  onFailedCb: () => void
) => {
  try {
    bybitHecate('Web3WalletBridge', 'selectWallet', {
      app_name: 'Web3',
      bizType: 'INSCRIPTION',
    })
      .then((res: any) => {
        console.log('selectWallet', res);
        onSuccessCb?.();
      })
      .catch(() => {
        console.log('selectWallet:error');
        onFailedCb?.();
      });
  } catch (error) {
    console.error(error);
  }
};

export const web3PurchaseWallet = async (
  chainCode = 'BTC',
  coinName = 'BTC',
  onSuccessCb?: () => void,
  onFailedCb?: () => void
) => {
  try {
    bybitHecate('Web3WalletBridge', 'web3Deposit', {
      app_name: 'web3',
      chainCode,
      coinName,
      contractAddress: '',
    })
      .then((res: any) => {
        console.log('web3Deposit', res);
        onSuccessCb?.();
      })
      .catch(() => {
        console.log('web3Deposit:error');
        onFailedCb?.();
      });
  } catch (error) {
    console.error(error);
  }
};

let token = '';
export const getUserToken = async () => {
  if (isApp() && !isInWeb3Mini()) {
    if (!token) {
      return new Promise((resolve) => {
        bybitHecate('UserProfile', 'getUserProfile', { needLogin: false })
          .then((res: any) => {
            console.log('jsBridge:getUserProfile', res);
            token = res.params ? res.params.userToken || '' : '';
            resolve(token);
          })
          .catch(({ message }: { message: string }) => {
            token = '';
            console.log('jsBridge:getUserProfile:error', message);
            resolve(token);
          });
      });
    } else {
      console.log('@@@@@@@');
    }
    return Promise.resolve(token);
  } else {
    return Promise.resolve('');
  }
};
export const subWalletChange = () => {
  if (isApp()) {
    bybitHecate('Web3WalletBridge', 'subSelectedWalletChanged', {
      app_name: 'web3',
    })
      .then((res: any) => {
        console.log('subSelectedWalletChangedResult', res);
      })
      .catch(() => {
        console.log('subSelectedWalletChangedResult:error');
      });
  }
};

export const getCurrentWalletByApp = async (
  onSuccessCb?: (res: {
    params: {
      result: {
        name: string;
        type: string;
        address: string;
        supportChainList: {
          address: string;
          chainCode: string;
          chainId: number;
          coinType: number;
          custodyPubKey: string;
          derivationPath: string;
          publicKey: string;
        }[];
      };
    };
  }) => void
) => {
  try {
    bybitHecate('Web3WalletBridge', 'selectedwallet', { app_name: 'web3' })
      .then((res) => {
        console.log('selectedwallet', res);
        onSuccessCb?.(res as any);
      })
      .catch(() => {
        console.log('selectedwallet:error');
      });
  } catch (error) {
    console.error(error);
  }
};

export const jumpToSearchPage = (
  nav: NavigateFunction,
  params: Record<string, string> = {}
) => {
  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  const path = 'by://web3/inscription/search';
  console.log('jumpToSearchPage params:', params, query);
  try {
    bybitHecate('Web3WalletBridge', 'openDeeplink', {
      app_name: 'Web3',
      deeplink: query && isInApp ? `${path}?${query}` : path, // 跳转到铭文搜索页面
    }).then((e: any) => {
      console.log(JSON.stringify(e));
      if (e?.params?.result) {
        nav(normalizeLink(`/project-detail?tick=${e.params.result}`));
      }
    });
  } catch (error) {
    console.error(error);
  }
};

const gt = (version1: string, version2: string) => {
  const list1 = version1.split('.');
  const list2 = version2.split('.');
  for (let i = 0; i < list1.length; i++) {
    if (list1[i] && !list2[i]) {
      return true;
    }
    if (+list1[i] < +list2[i]) {
      return false;
    }
  }
  return true;
};

export const versionDetect = (cb: (status: boolean) => void) => {
  const supportedVersion = '4.35.0';
  const supportedHideNavBarVersion = '4.35.0';
  try {
    bybitHecate('SystemInfo', 'getAppConfig', {}).then((res: any) => {
      const { appVersion = '' } = res?.params || res || {};
      const appSupported = gt(appVersion, supportedVersion);
      isSupportHideNavBar = gt(appVersion, supportedHideNavBarVersion);
      console.log(
        'appVersion:',
        appVersion,
        'appSupported:',
        appSupported,
        isSupportHideNavBar
      );
      // alert('appVersion:'+appVersion+",appSupported:"+appSupported);
      if (cb) {
        cb(appSupported);
      }
    });
  } catch (e) {
    console.error(e);
  }
};

export let isInApp: boolean = false;
export let isSupportHideNavBar: boolean = false;

export const detectIsInApp = () => {
  if (isBrowser) {
    versionDetect((status) => {
      isInApp = status;
    });
  }
};

const addFirstViewPathParams = (url: string = '') => {
  const hasQuery = url.includes('?');
  const div = hasQuery ? '&' : '?';
  const params = `${div}firstViewPath=${encodeURIComponent(url)}`;
  return `${url}${params}`;
};

export const openWebview = (link: string, hidden: boolean = true) => {
  const origin = window.location.origin;
  const path = addFirstViewPathParams(normalizeLink(link));
  const isFullUrl = link?.includes('http');
  let url = isFullUrl ? link : `${origin}${path}`;
  console.log('openWebview:', url);

  if (location.search) {
    const appendSearch = window.location.search.slice(1);
    const hasQuery = url.includes('?');
    url = `${url}${hasQuery ? '&' : '?'}${appendSearch}`;
  }

  try {
    bybitHecate('Web3WalletBridge', 'openDeeplink', {
      app_name: 'Web3',
      hiddenNaviBar: hidden && isSupportHideNavBar,
      deeplink: url, // 跳转到铭文搜索页面
    }).then((e: any) => {
      console.log(JSON.stringify(e));
    });
  } catch (error) {
    console.error(error);
  }
};

const parseSearch = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  const searchStr = window.location.search?.slice(1) || '';
  const parts = searchStr.split('&');
  const params: Record<string, string> = {};
  for (let i = 0; i < parts.length; i++) {
    const [key, value] = parts[i].split('=');
    params[key] = value;
  }
  return params;
};

export const useNav = () => {
  const nav = useNavigate();

  const goBack = () => {
    // alert('test go back');
    const params = parseSearch();
    const url = decodeURIComponent(params?.['firstViewPath']) || '';
    const isCurrentPage = params?.['firstViewPath']
      ? window.location.pathname === url.split('?')?.[0]
      : false;

    // console.log('url:', window.location.pathname, isCurrentPage);

    if (isCurrentPage) {
      closePage();
      return;
    }
    nav(-1);
  };

  const goDownload = () => {
    nav(normalizeLink(downloadPath));
  };

  const navTo = (path: string) => {
    const fullPath = normalizeLink(path);
    if (location.search) {
      const appendSearch = window.location.search.slice(1);
      const hasQuery = fullPath.includes('?');
      const fullLink = `${fullPath}${hasQuery ? '&' : '?'}${appendSearch}`;
      nav(fullLink);
      return;
    }

    nav(fullPath);
  };

  return { goBack, goDownload, navTo };
};

//  bybitHecate('NavigationBar', 'setNavigationBarHidden', {isHidden:true})
export const closePage = () => {
  try {
    bybitHecate('Navigator', 'closePage', {}).then((e) => {
      console.log(JSON.stringify(e));
    });
  } catch (error) {
    console.error(error);
  }
};

export const hideNavBar = () => {
  if (!isSupportHideNavBar) {
    return;
  }
  try {
    bybitHecate('NavigationBar', 'hide', {}).then((e) => {
      console.log(JSON.stringify(e));
    });
  } catch (error) {
    console.error(error);
  }
};

export const setNavBarTitle = (title: string = '') => {
  try {
    document.title = title;
    bybitHecate('NavigationBar', 'setTitle', { title: title }).then((e) => {
      console.log(JSON.stringify(e));
    });
  } catch (error) {
    console.error(error);
  }
};

export const openBrowser = (
  url: string,
  // @ts-ignore
  external?: boolean = false,
  hidden?: boolean = false
) => {
  if (isInApp && !external) {
    openWebview(url, hidden || false);
    return;
  }
  try {
    bybitHecate('UrlLauncher', 'open', { url }).then((e) => {
      console.log(JSON.stringify(e));
    });
  } catch (error) {
    console.error(error);
  }
};
